module.exports = __webpack_public_path__ + "static/media/Jaime Lannister 2.597a29cd.jpg";